/* global chrome */
import React from 'react';
import LoadingScreen from 'components/loadingScreen';

import LibraryShell from 'components/library/LibraryShell';
import LibraryToolbar from 'components/library/LibraryToolbar';
import { TldrawBoard } from 'canvas';
import { useLibraryNav } from 'components/library/useLibraryNav';

import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { usePersonStore } from 'stores';

import 'components/library/index.css';

const LibraryCanvasPage = () => {
  const personStore = usePersonStore();
  const { loadPerson } = personStore;
  const user = useSelector(state => state.user);
  const { person, userCanvasMapping, loadedTime } = personStore;

  const params = useParams();

  const libraryNav = useLibraryNav();
  const {
    activeSection,
    searchQuery,
    boardName,
    sectionTitle,
    navigateAll,
    navigateBoard,
    navigateCreate,
    setViewMode,
  } = libraryNav;

  const profileUsername = params.person_name
    ? decodeURIComponent(params.person_name)
    : null;

  const isOwnerProfile = Boolean(
    user &&
      (person
        ? String(person._id) === String(user._id)
        : profileUsername &&
          user.username &&
          user.username.toLowerCase() === profileUsername.toLowerCase())
  );

  React.useEffect(() => {
    if (!person && params.person_name) {
      loadPerson(params.person_name, true);
    }
  }, [person, params.person_name, loadPerson]);

  if (personStore.loading && !person) {
    return <LoadingScreen fullScreen={false} message="Loading your visual memory" />;
  }

  if (!person) return null;

  const isOwner = isOwnerProfile;

  return (
    <>
      <LibraryShell
        flushContent
        toggleSidebar
        sidebarProps={{
          activeSection,
          boardName,
          searchQuery,
          person,
          isOwner,
          userCanvasMapping,
          showProfileHeader: true,
          ownerUsernameTooltip: isOwner
            ? `This is @${person.username} — the username your friends use to message you.`
            : '',
          onNavigateAll: navigateAll,
          onNavigateBoard: name => navigateBoard(name),
          onNavigateCreate: navigateCreate,
        }}
        toolbar={
          <LibraryToolbar
            title={sectionTitle}
            viewMode="canvas"
            boardName={boardName}
            pinCount={personStore.activities?.length || 0}
            onViewModeChange={setViewMode}
            personName={params.person_name}
            isOwner={isOwner}
          />
        }
      >
        <TldrawBoard
          personName={params.person_name}
          hashtag={params.keyword}
          loadedTime={loadedTime}
        />
      </LibraryShell>
    </>
  );
};

export default LibraryCanvasPage;
